import { usePage } from '@inertiajs/react';
import { hasPermission as hasPermissionUtil } from '@Pages/pageRuntime/lib/permissions';

import type { PageProps } from '@/types';

/**
 * Hook to access permission checking functions for the current authenticated user
 */
export function usePermissions() {
  const { identity } = usePage<PageProps>().props;
  const user = identity;

  const hasPermission = (permission: Diagonal.Core.Enums.SystemPermission) =>
    hasPermissionUtil(user, permission);

  return {
    user,
    hasPermission
  };
}
